import { jsx as _jsx } from "react/jsx-runtime";
import TrackInteractionContext from '../../contexts/track-interaction-context';
import useEventTracker from './hooks/use-event-tracker';
function TrackInteractionProvider({ children, ...trackerParams }) {
    const { trackEvent, identify } = useEventTracker(trackerParams);
    return (_jsx(TrackInteractionContext.Provider, { value: {
            trackEvent,
            identify,
        }, children: children }));
}
export default TrackInteractionProvider;
